import { CCArticleResult } from "../../Models/Assessment";
import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";

interface IProps {
    articleResults: Array<CCArticleResult>;
}

export function ArticleResultList(props: IProps) {
    return (
        <div className="pp-assessment-table">
            <Table className="pp-assessment-table">
                <thead>
                    <tr>
                        <th scope="col" className="font-weight-bolder mb-1 pp-font-size-smaller">Article</th>
                        <th scope="col" className="font-weight-bolder mb-1 pp-font-size-smaller">Completed</th>
                        <th scope="col" className="font-weight-bolder mb-1 pp-font-size-smaller">Result</th>
                    </tr>
                </thead>
                <tbody>
                    { props.articleResults.map((articleResult: CCArticleResult) => {
                            return (
                                <tr key={articleResult.esoArticleId} className="pp-font-size-smaller">
                                    <td>{articleResult.articleTitle}</td>
                                    <td>{getDateWithOffset(articleResult.completedDate).toLocaleDateString()}</td>
                                    <td>{articleResult.isPass ? "Pass" : "Fail"}
                                        {articleResult.isPass && articleResult.rescore &&                      
                                        <OverlayTrigger
                                            placement={"right"}
                                            overlay={<Tooltip id="articleRescore" bsPrefix="pp-tooltip">
                                                Rescored on {getDateWithOffset(articleResult.rescoreDate).toLocaleDateString()}. Result updated.
                                        </Tooltip>}>
                                         <i className="las la-info-circle ml-1 text-pp-secondary"></i>
                                        </OverlayTrigger>
                                        }
                                    </td>
                                </tr>
                            )
                    })}
                </tbody>
            </Table>
        </div>

        
    );
}
